<template>
  <div id="goTop">
    <div class="goTop" v-show="goTopShow" @click="goTop">
      <img src="../assets/images/backTop.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: "goTop",
  props: ['top'],
  data() {
    return {
      scrollTop: "",
      goTopShow: false,
    };
  },
  watch: {
    scrollTop(val) {
      if (this.scrollTop > 100) {
        this.goTopShow = true;
      } else {
        this.goTopShow = false;
      }
    },
    top() {
      if (this.top > 100) {
        this.goTopShow = true;
      } else {
        this.goTopShow = false;
      }
    },
  },
  created() {

  },
  methods: {
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.scrollTop > 100) {
        this.goTopShow = true;
      }
    },
    goTop() {
      let timer = null,
        _that = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (_that.top) {
           _that.$emit('func',_that.top);
        } else {
          if (_that.scrollTop > 0) {
            _that.scrollTop -= 50;
            document.body.scrollTop = document.documentElement.scrollTop =
              _that.scrollTop;
            timer = requestAnimationFrame(fn);
          } else {
            cancelAnimationFrame(timer);
            _that.goTopShow = false;
          }
        }
      });
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};

</script>
<style scoped>
.goTop {
  position: fixed;
  right: 1.066667rem;
  bottom: 1.6rem;
  width: 1.066667rem;
  height: 1.066667rem;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
}

.goTop img {
  width: 100%;
}

</style>
